import { useInfiniteQuery } from '@tanstack/react-query';
import { apiFetch, type Page } from './client';

/** Every list endpoint shares the same { data, next_cursor } envelope (NF3) — one hook for all of them. */
export function usePage<T>(
  queryKey: unknown[],
  path: string,
  query: Record<string, string | number | boolean | undefined> = {},
) {
  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      apiFetch<Page<T>>(path, { query: { ...query, cursor: pageParam } }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.next_cursor ?? undefined,
  });
}
